/*
 * @Author: Axs <i@axs.email>
 * @Date: 2022-07-01 10:15:09
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-07-01 17:15:12
 * @Description:
 * @FilePath: /src/api/modules/coupon.js
 */
// 电影票获取优惠券列表
export const GET_MOVIE_COUPON_LIST = '/api/movieCard/pagedQuery';

// 电影票兑换优惠券
export const EXCHANGE_MOVIE_COUPON = '/api/movieCard/exchange';

// 获取可用的优惠券
export const GET_AVAILABLE_COUPON_LIST = '/api/movieCard/listAvailable';

// 使用优惠券
export const USE_MOVIE_COUPON = '/api/movieCard/use';

// 取消使用优惠券
export const CANCEL_USE_MOVIE_COUPON = '/api/movieCard/unUse';
